import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import DataTables from 'organisms/DataTable';
import { actionFormatter } from 'molecules/TableFormatters';
import { blastingReportCreate, blastingReportDelete, blastingReportUpdate, blastingReportApproval, blastingReportRead } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getContractorPitLookupData } from 'Redux/actions/LookupActions';
import { getBlastingReportDetail, getAllBlastingData } from 'Redux/actions/BlastingReportActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FilterCol, FilterRow, PageWrapper, RoundedWrapper, StyledDatePicker, TableWrapper } from './styles';
import lo from 'lodash';
import ModalPage from 'components/templates/ModalPage/index';
import { NewBlastingReport } from 'fixtures/TemplateData';
import NewBlastingReportModal from 'components/organisms/NewBlastingReportModal/index';
import SendBackRemarkModal from 'components/organisms/SendBackRemarkModal/index';
import { v4 as uuidv4 } from 'uuid';
import { postNewData, deleteData } from 'services/cmsService';
import { BLASTING_REPORTS, BLASTING_REPORTS_APPROVAL, BLASTING_REPORTS_ATTACHMENT } from 'fixtures/api';
import moment from 'moment'
import { TxtSuccessAddBlastReport, TxtSuccessSendBackBlastReport, TxtSuccessApproveBlastReport, TxtSuccessEditBlastReport } from 'fixtures/texts';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { Label } from 'components/atoms/Texts/TxtLabel';
import IconPng from 'components/atoms/IconPng/index';
import { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom'
import { ROUTE_DASH_BLASTING_REPORT } from 'fixtures/routes';
import { statusBtnFormatter } from 'components/molecules/TableFormatters/statusBtnFormatter';

const ic_eye = require('App/assets/images/ic_eye.png')
const defaultFilter = {
  blastingDate: new Date(),
  pitId: '',
  contractorId: '',
}
export class BlastingReportList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowModal: false,
      isShowRemarkModal: false,
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
      blastingReportData: {},
      sendBackRemarkData: {},
      filter: lo.cloneDeep(defaultFilter),
      lookups: {
        pits: [],
        contractors: props.userLogin.userDetail.contractor ? [props.userLogin.userDetail.contractor] : props.contractorPitLookups
      },
      localFilter: { pitId : '' },
      navList: [
        'Blasting Report',
        'Blasting Report List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      allowApproval: false,
    }

  }

  componentDidMount() {
    const { match: { params } } = this.props
    const { id } = params
    this.props.toggleIsLoading(true)
    this.initFilter()
    this.props.getContractorPitLookupData().then(() => {
      this.checkOwnerOrMainContractor()
    })
    this.checkPermission()
    if (id) {
      this.props.getBlastingReportDetail(id)
    }
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
    
    if (this.props.blastingReportDetail !== prevProps.blastingReportDetail) {
      const newData = lo.cloneDeep(this.props.blastingReportDetail)
      this.switchModal(newData)
    }
    
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, blastingReportCreate),
        allowDelete: permissionCheck(permissions, blastingReportDelete),
        allowUpdate: permissionCheck(permissions, blastingReportUpdate),
        allowApproval: permissionCheck(permissions, blastingReportApproval),
      })
    }
  }

  initFilter() {
    if (sessionStorage.getItem('dataBlastingFilters') && sessionStorage.getItem('dataBlastingLookups')) {
      const filter = JSON.parse(sessionStorage.getItem('dataBlastingFilters'))
      const lookups = JSON.parse(sessionStorage.getItem('dataBlastingLookups'))
      this.setState({ filter, lookups })
    }
  }

  checkOwnerOrMainContractor() {
    const { userLogin, contractorPitLookups } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions, contractor } } = userLogin
      if(permissionCheck(permissions, blastingReportRead) && contractor){
        const contractorData = contractorPitLookups.find(item => item.id === contractor.id)
        this.setState({
          lookups: { ...this.state.lookups, contractors: [contractor], pits: contractorData ? contractorData.pits : [] }, 
          filter: { ...this.state.filter, contractorId: contractor.id } 
        }, () => {
          this.onFilterSubmit()
        })
      } else if(permissionCheck(permissions, blastingReportRead) && !contractor){
        const allPits = contractorPitLookups.map(el => el.pits).flat()
        this.setState({ lookups: { ...this.state.lookups, contractors: this.props.contractorPitLookups,pits: allPits } }, () => {
          this.onFilterSubmit()
        })
      } else {
        this.onFilterSubmit()
      }
    }
  }
  
  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  /**
   * method for handling add new blasting report
   */
  addNewBlastingReport() {
    const { userLogin } = this.props
    const contractorId = userLogin.userDetail ? userLogin.userDetail.contractorId : '-'
    this.switchModal(lo.cloneDeep({...NewBlastingReport, contractorId}))
  }

  switchModal(blastingReportData, initSwitch = () => {}) {
    const { isShowModal } = this.state
    const { history: { push } } = this.props
    initSwitch()
    this.setState({ blastingReportData }, () => {
      this.setState({ isShowModal: !isShowModal }, () => {
        if (!this.state.isShowModal) {
          push(`/dash/${ROUTE_DASH_BLASTING_REPORT}`)
        }
      })
    })
  }

  /**
   * method for handling change data on blasting report form
   * @param {*} val 
   * @param {string} field 
   */
  onChangeUserData(val, field) {
    let blastingReport = Object.assign(this.state.blastingReportData)
    blastingReport[field] = val

    this.setState({ blastingReportData: blastingReport })
  }

  /**
   * method for submit blasting report data
   **/
  onSubmitUser = async () => {
    const { toggleIsLoading, contractorPitLookups } = this.props
    const { blastingReportData } = this.state

    try {
      toggleIsLoading(true)
      const formattedBlastingReportData = JSON.parse(JSON.stringify(blastingReportData), (key, value) => {
        // check if the current value is a string containing numbers and commas
        if (typeof value === "string" && /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(value)) {
          // replace the commas with an empty string
          return value.replace(/,/g, "")
        }
        // return the original value for other types
        return value
      })

      // add pitName attribute
      formattedBlastingReportData.details.detailPit.forEach((pit) => {
        const found = contractorPitLookups.find(el => el.id === parseInt(blastingReportData.contractorId))
        if (found) {
          const pitObj = found.pits.find(obj => obj.id === parseInt(pit.pitInfo.pit))
          pit.pitInfo.pitName = pitObj ? pitObj.name : ""
        }
      })

      // loop to upload each attachment
      for (const pit of formattedBlastingReportData.details.detailPit) {
        for (const attachment of pit.attachments) {
          if (attachment.hasOwnProperty('file')) {
            try {
              // regenerate attachment id if first report submission fails to handle upload attachment failed
              attachment.id = uuidv4()
              const res = await postNewData(BLASTING_REPORTS_ATTACHMENT, attachment)
              if (res.status === 200 || res.status === 201 || res.status === 204) {
                attachment.id = res.data.id
                attachment.filename = res.data.filename
              } else {
                throw res
              }
            } catch (error) {
              alert(error.message)
            }
          }
        }
        pit.attachments = pit.attachments.map(({ id, filename }) => ({ id, filename }))
      }

      // stores all attachment ids for each pit
      let currentAttachmentList = formattedBlastingReportData.details.detailPit.flatMap(
        (pit) => pit.attachments.map((attachment) => attachment.id)
      )

      if (formattedBlastingReportData.hasOwnProperty('attachments')) {
        const existingAttachmentList = formattedBlastingReportData.attachments.map(({id}) => id)

        // find new attachment ids that are not in existingAttachmentList
        const newAttachmentList = currentAttachmentList.filter(
          (attachmentId) => !existingAttachmentList.includes(attachmentId)
        )
        formattedBlastingReportData.attachments = newAttachmentList.length > 0 ? newAttachmentList : existingAttachmentList

        // find deleted attachment ids
        const deletedAttachmentList = existingAttachmentList.filter(
          (attachmentId) => !currentAttachmentList.includes(attachmentId)
        )

        // loop through deletedAttachmentList and delete each attachment
        deletedAttachmentList.forEach(async (attachmentId) => {
          try {
            await deleteData(`${BLASTING_REPORTS_ATTACHMENT}/${attachmentId}`)
          } catch (error) {
            alert(error.message)
          }
        })
      } else {
        formattedBlastingReportData.attachments = currentAttachmentList
      }

      let successMessage = TxtSuccessAddBlastReport
      if (!formattedBlastingReportData.hasOwnProperty('id')) {
        // add id property if it doesn't exist
        formattedBlastingReportData.id = uuidv4()
      } else {
        successMessage = TxtSuccessEditBlastReport
        // remove some properties when updating data
        let deletedKey = ['status', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy', 'approvalLogs', 'contractor']
        for (let key of deletedKey) {
          delete formattedBlastingReportData[key];
        }
      }
      formattedBlastingReportData.drillDate = moment(formattedBlastingReportData.drillDate).format('YYYY-MM-DD')
      formattedBlastingReportData.blastingDate = moment(formattedBlastingReportData.blastingDate).format('YYYY-MM-DD')

      const res = await postNewData(BLASTING_REPORTS, formattedBlastingReportData)

      if (res.status < 400) {
        alert(successMessage)
        this.switchModal(blastingReportData)
        this.onFilterSubmit()
      } else {
        const message = res.errors? res.errors.length > 0 ? res.errors[0].message : res.message : `Failed to submit blasting report`
        alert(message)
        throw res
      }
    } catch (error) {
      console.error(error);
    } finally {
      toggleIsLoading(false)
    }
  }

  switchRemarkModal() {
    const { isShowRemarkModal } = this.state
    this.setState({ isShowRemarkModal: !isShowRemarkModal })
  }

  onChangeRemarkData(val) {
    let sendBackRemark = Object.assign(this.state.sendBackRemarkData)
    sendBackRemark.remark = val

    this.setState({ sendBackRemarkData: sendBackRemark })
  }

  onSubmitRemark = async () => {
    const { toggleIsLoading } = this.props
    const { sendBackRemarkData, blastingReportData } = this.state

    try {
      toggleIsLoading(true)
      let remarkData = lo.cloneDeep(sendBackRemarkData)
      if (!remarkData.remark) {
        alert("Remark is required")
        return
      }
      const res = await postNewData(BLASTING_REPORTS_APPROVAL, remarkData)

      if (res.status < 400) {
        alert(TxtSuccessSendBackBlastReport)
        this.switchRemarkModal()
        this.switchModal(blastingReportData)
        this.onFilterSubmit()
      } else {
        const message = res.errors ?  res.errors[0].message : `Failed to send back this blasting report`
        alert(message)
        throw res
      }
    } catch (error) {
      console.error(error);
    } finally {
      toggleIsLoading(false)
    }
  }

  // method for send back blasting report
  onSendBack() {
    const { isShowRemarkModal, blastingReportData } = this.state
    this.setState({ isShowRemarkModal: !isShowRemarkModal }, () => {
      this.setState({
        sendBackRemarkData: {
          id: blastingReportData.id,
          approval: "SENDBACK",
          remark: "",
        }
      })
    })
  }

  // method for approve blasting report
  onApprove = async () => {
    const { toggleIsLoading } = this.props
    const { blastingReportData } = this.state
    const approvalData = {
      id: blastingReportData.id,
      approval: "APPROVED"
    }

    try {
      toggleIsLoading(true)
      const res = await postNewData(BLASTING_REPORTS_APPROVAL, approvalData)

      if (res.status < 400) {
        alert(TxtSuccessApproveBlastReport)
        this.switchModal(blastingReportData)
        this.onFilterSubmit()
      } else {
        const message = res.errors ?  res.errors[0].message : `Failed to approve this blasting report`
        alert(message)
        throw res
      }
    } catch (error) {
      console.error(error);
    } finally {
      toggleIsLoading(false)
    }
  }

  
  // method to change filter state
  onChangeFilter(val, field) {
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f }, () => {
      if (field === 'contractorId') {
        const { contractorPitLookups } = this.props
        const pits = !val ? 
          contractorPitLookups.map(el => el.pits).flat() : 
          contractorPitLookups.find(el => el.id === Number(val)).pits
        this.setState({ 
          lookups: {
            ...this.state.lookups,
            pits: pits || []
          }, 
          filter: {
            ...this.state.filter,
            pitId: ''
          }
        })
      }
    })
  }

  onFilterSubmit() {
    this.props.toggleIsLoading(true)
    const { blastingDate, contractorId } = this.state.filter
    const query = new URLSearchParams({
      blastingDate: blastingDate ? moment(blastingDate).format('YYYY-MM-DD') : '',
      contractorId: !!contractorId && contractorId !== '-' ? contractorId : '',
    })
    this.setState({ localFilter: this.state.filter }, () => {
      window.sessionStorage.setItem("dataBlastingFilters", JSON.stringify(this.state.localFilter))
      window.sessionStorage.setItem("dataBlastingLookups", JSON.stringify(this.state.lookups))
    })
    this.props.getAllBlastingData(query.toString(), ()=> {
      this.props.toggleIsLoading(false)
    })
  }

  onResetFilter() {
    this.setState({ filter: lo.cloneDeep(defaultFilter) }, () => {
      this.setState({ localFilter: lo.cloneDeep(defaultFilter) })
      this.onFilterSubmit()
    })
    window.sessionStorage.removeItem("dataBlastingFilters")
    window.sessionStorage.removeItem("dataBlastingLookups")
  }

  getPitFilterData(data, pitId) {
    return pitId && pitId !== '-' ? data.filter(item => {
      return item.pit === pitId
    }) : data
  }

  onSummary() {
    this.props.history.push(`${ROUTE_DASH_BLASTING_REPORT}/report/summary`)
  }

  renderFilterRow(isContractor) {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
    }

    const { filter, lookups } = this.state

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Date
          </Label>
          <StyledDatePicker
            onChange={date => this.onChangeFilter( date, 'blastingDate')}
            value={filter.blastingDate ? new Date(filter.blastingDate) : null}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Contractor
          </Label>
          <FormSelect
            placeholder={`Select contractor`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'contractorId')}
            options={[
            ...isContractor ? [] : [{
              name: 'All Contractors',
              id: ''
            }], 
            ...lookups.contractors]}
            value={filter.contractorId}
            valField={'id'}
            dispField={'name'}
            arrowSize={'5%'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Pit
          </Label>
          <FormSelect
            placeholder={`Select pit`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'pitId')}
            options={[{
              name: 'All Pits',
              id: ''
            }, ...lookups.pits]}
            value={filter.pitId}
            valField={'id'}
            dispField={'name'}
            arrowSize={'5%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>

        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
          margin={'0 9px 0 0'}
        />
        <ButtonReg
          btnTxt="Reset"
          rad={'6px'}
          disabled={false}
          onClick={this.onResetFilter.bind(this)}
          height={'34px'}
          width={'50px'}
        />
      </FilterRow>
    )
  }

  render() {
    const { navList, isShowModal, isError, isSubmitDisabled, blastingReportData, 
      allowApproval, isShowRemarkModal, sendBackRemarkData, localFilter } = this.state
    const { userLogin, settingsTable, blastingReports, viewState: { isLoading, isMobileView }, theme } = this.props
    const isContractor = !!userLogin.userDetail.contractorId

    const sizePerPage = settingsTable.sizePerPage[navList[0]]
    const dataBlastingReports = this.getPitFilterData(blastingReports, localFilter.pitId)
    
    const config = [
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 100 : 150 },
        formatter: actionFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          edit: (row) => () => {
            this.props.history.push(`blasting-report/${row.id}`)
          }
        },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true
      },
      {
        dataField: 'pitName',
        text: 'Pit',
        sort: true,
      },
      {
        dataField: 'drillDate',
        text: 'Drill Date',
        sort: true
      },
      {
        dataField: 'blastingDate',
        text: 'Blasting Date',
        sort: true
      },
      {
        dataField: 'contractor.name',
        text: 'Contractor',
        sort: true
      },
      {
        dataField: 'sectionFrom',
        text: 'Section From',
        sort: true
      },
      {
        dataField: 'sectionTo',
        text: 'Section To',
        sort: true
      },
      {
        dataField: 'rl',
        text: 'RL',
        sort: true
      },
      {
        dataField: 'actual',
        text: 'Actual',
        sort: true
      },
      {
        dataField: 'reportedBy',
        text: 'Reported By',
        sort: true
      },
      {
        dataField: 'remark',
        text: 'Remarks',
        hidden: true
      },
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
        formatter: statusBtnFormatter,
        formatExtraData: {
          field: 'status',
          type: 'Blasting Report',
          auto: true,
          theme,
        }
      },
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          ignoreBackgroundClick
          ignoreEscapeKeydown
          contentChild={
            <NewBlastingReportModal
              fnChange={this.onChangeUserData.bind(this)}
              fnSubmit={this.onSubmitUser.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              fnSendBack={this.onSendBack.bind(this)}
              fnApprove={this.onApprove.bind(this)}
              blastingReportData={blastingReportData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              allowApproval={allowApproval}
              {...this.props}
            />
          }
        />
        <ModalPage
          isOpen={isShowRemarkModal}
          size={'25vw'}
          fnSwitch={this.switchRemarkModal.bind(this)}
          contentChild={
            <SendBackRemarkModal
              fnChange={this.onChangeRemarkData.bind(this)}
              fnSubmit={this.onSubmitRemark.bind(this)}
              fnSwitch={this.switchRemarkModal.bind(this)}
              sendBackRemarkData={sendBackRemarkData}
              {...this.props}
            />
          }
        />
        <RoundedWrapper>
          {this.renderFilterRow(isContractor)}
        </RoundedWrapper>
        {!isLoading &&
          <TableWrapper>
            <DataTables
              leftSlot={
                <>
                {this.state.allowCreate && isContractor &&
                  <ButtonReg
                    btnTxt={'Add'}
                    disabled={false}
                    onClick={() => this.addNewBlastingReport()}
                    width={'78px'}
                    margin={'0 9px 0 0'}
                  />
                }
                  <ButtonReg
                    btnTxt={'Summary'}
                    disabled={['', '-'].indexOf(this.state.localFilter.contractorId) > -1 || !dataBlastingReports.length}
                    onClick={() => this.onSummary()}
                  />
                </>
              }
              isMobile={isMobileView}
              fnEdit={this.fnEdit}
              isInlineEdit={true}
              dataList={dataBlastingReports}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </TableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contractorPitLookups: state.contractorPitLookups,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable,
    blastingReportDetail: state.blastingReportDetail,
    blastingReports: state.blastingReports,
    pitsLookup: state.contractorPitLookups.reduce((acc, item) => {
      item.pits.forEach(pit => {
        acc.push(pit)
      })
      return acc
    }, [])
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
      getContractorPitLookupData,
      getBlastingReportDetail,
      getAllBlastingData
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BlastingReportList)
  )
)
